<template>
  <div class="row">
   

    <div class="col-md-6 col-sm-6 col-lg-6 col-xl-4">
      <div @click="$router.push('/agent-ai-v2')" style="cursor:pointer" class=" card dash-widget">
        <div class="card-body">
          <span class="dash-widget-icon">
            <i class="fa fa-reply-all"></i>
          </span>
          <div class="dash-widget-info">
            <h3>{{ statAIChatBot.balasOtomatis }}</h3>
            <span>Balas Otomatis</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-sm-6 col-lg-6 col-xl-4">
      <div @click="$router.push('/agent-ai-v2')" style="cursor:pointer" class=" card dash-widget">
        <div class="card-body">
          <span class="dash-widget-icon">
            <i class="fa fa-briefcase"></i>
          </span>
          <div class="dash-widget-info">
            <h3>{{ statAIChatBot.balasJamKerja }}</h3>
            <span>Balas Dijam Kerja</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-sm-6 col-lg-6 col-xl-4">
      <div @click="$router.push('/agent-ai-v2')" style="cursor:pointer" class=" card dash-widget">
        <div class="card-body">
          <span class="dash-widget-icon">
            <i class="fa fa-moon-o"></i>
          </span>
          <div class="dash-widget-info">
            <h3>{{ statAIChatBot.balasLuarJamKerja }}</h3>
            <span>Balas Diluar Kerja</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      statAIChatBot: {
        total: 0,
        balasOtomatis: 0,
        balasJamKerja: 0,
        balasLuarJamKerja: 0,
      },
      statAIChat: {
        totalActive: 0,
        totalDitunda: 0,
        totalSelesai: 0,
      },
      statAIChatSummary: {
        needFollowUp: 0,
        followUpHasScheduled: 1,
      },
    };
  },
  async created() {
    this.getStatAIChatBot();
    // await this.getStatAIChat();
    // await this.getStatAIChatSummary();
  },
  methods: {
    async getStatAIChatBot() {
      this.$store
        .dispatch("dashboard/statAIChatBot") // sesuai kan dengan method di API
        .then((response) => {
          var { data } = response;
          this.statAIChatBot = data;
        });
    },
    async getStatAIChat() {
      this.$store
        .dispatch("dashboard/statAIChat") // sesuai kan dengan method di API
        .then((response) => {
          var { data } = response;
          this.statAIChat = data;
        });
    },
    async getStatAIChatSummary() {
      this.$store
        .dispatch("dashboard/statAIChatSummary") // sesuai kan dengan method di API
        .then((response) => {
          var { data } = response;
          this.statAIChatSummary = data;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ai/chatbot/overview/ChatBot.vue